// eslint-disable-next-line import/no-unresolved
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
// eslint-disable-next-line import/no-extraneous-dependencies
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin';
import Base from '../../_config/base';

class Gallery extends Base {
  constructor(el) {
    super(el);
    this.initPhotoSwipe();
  }

  initPhotoSwipe() {
    const galleryElement = this.$el;

    const lightbox = new PhotoSwipeLightbox({
      gallery: galleryElement,
      children: 'a',
      pswpModule: PhotoSwipe,
      showHideAnimationType: 'fade',
      showAnimationDuration: 300,
      hideAnimationDuration: 300,
      enableZoom: false,
    });

    // Add the dynamic caption plugin
    // eslint-disable-next-line no-unused-vars
    const captionPlugin = new PhotoSwipeDynamicCaption(lightbox, {
      type: 'below',
      captionContent: (slide) => {
        const { element } = slide.data;
        return element?.getAttribute('data-pswp-caption');
      },
    });

    // Initialize the lightbox
    lightbox.init();
  }
}

Gallery.className = 'Gallery';
export default Gallery;
